// src/views/customer/booking/components/BookingConstants.js

export const DAY_NAMES = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"]

export const GENDER_FILTERS = [
    { value: "all", label: "Tümü" },
    { value: "female", label: "Kadın" },
    { value: "male", label: "Erkek" },
]

export const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
}

export const getInitials = (name) => {
    if (!name) return "?"
    const parts = name.split(" ")
    if (parts.length === 1 && parts[0].length > 1) return parts[0].substring(0, 2).toUpperCase()
    const firstInitial = parts[0][0] || ""
    const lastInitial = parts[parts.length - 1][0] || ""
    return `${firstInitial}${lastInitial}`.toUpperCase()
}

export const timeToMinutes = (timeStr) => {
    if (!timeStr) return 0
    const [hours, minutes] = timeStr.split(":").map(Number)
    return hours * 60 + minutes
}

export const transformWorkDaysToSchedule = (workDays) => {
    const schedule = {}
    workDays.forEach((day) => {
        if (day.is_active) {
            schedule[day.day_of_week] = {
                start: day.start_time,
                end: day.end_time,
            }
        }
    })
    return schedule
}